import React from 'react'
import { SVGIconProps } from '../types'
const SvgArrowLeft = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m14 7-5 5 5 5z" />
    <path fill="none" d="M24 0v24H0V0z" />
  </svg>
)
export default SvgArrowLeft
